import { takeEvery, select, put } from 'redux-saga/effects';
import { apiRequest } from './index';
import api from 'utils/api';
import { get } from 'lodash';
import * as memberActions from 'actions/Member';
import history from 'utils/history';
import { Slide, toast } from 'react-toastify';
import * as organizationActions from '../actions/Organizations';
import { t } from 'i18n';
const getMembers = apiRequest.bind(null, memberActions.getMembers, api.getMembers);
const getActiveMembers = apiRequest.bind(null, memberActions.getActiveMembers, api.getMembers);
const getInactiveMembers = apiRequest.bind(null, memberActions.getInactiveMembers, api.getMembers);
const getMember = apiRequest.bind(null, memberActions.getMember, api.getMember);
const getRoles = apiRequest.bind(null, memberActions.getRoles, api.getRoles);
const createMember = apiRequest.bind(null, memberActions.createMember, api.createMember);
const createMemberByAdmin = apiRequest.bind(null, memberActions.createMemberByAdmin, api.createMemberByAdmin);
const updateMember = apiRequest.bind(null, memberActions.updateMember, api.updateMember);
const updateMemberByAdmin = apiRequest.bind(null, memberActions.updateMemberByAdmin, api.updateMemberByAdmin);
const deleteMember = apiRequest.bind(null, memberActions.deleteMember, api.deleteMember);
const deleteMemberByAdmin = apiRequest.bind(null, memberActions.deleteMemberByAdmin, api.deleteMemberByAdmin);
const updateMemberPassword = apiRequest.bind(null, memberActions.updateMemberPassword, api.updateMemberPassword);

function* refreshList(action) {
  const state = yield select();
  if (window.location.pathname.includes('organization')) {
    const arg = {
      id: get(state, 'Organizations.childOrganization.id'),
    };

    yield apiRequest.apply(null, [organizationActions.getChildOrganization, api.getChildOrganization, arg]);
  } else {
    yield put({
      type: memberActions.GET_MEMBERS.REQUEST,
      payload: {
        data: {
          page: 0,
          memberContains: get(state, 'Members.tableFilter.search'),
        },
      },
    });
  }

  //remove all toast messages created by api-calls/page/... before displaying success message
  yield toast.dismiss();
  yield toast(t('messages.saved'), {
    transition: Slide,
    closeButton: true,
    autoClose: 2000,
    position: 'bottom-center',
    type: 'success',
  });
}

function* handleCreateMemberSuccess(action) {
  if (action.payload.options === 'redirect') {
    return yield history.push('/admins');
  } else {
    yield history.push(`/update-admin/${action.payload.id}`);

    const arg = { id: action.payload.id };

    yield apiRequest.apply(null, [memberActions.getMember, api.getMember, arg]);

    //remove all toast messages created by api-calls/page/... before displaying success message
    yield toast.dismiss();
    yield toast(t('messages.saved'), {
      transition: Slide,
      closeButton: true,
      autoClose: 2000,
      position: 'bottom-center',
      type: 'success',
    });
  }
}

function* showMessage() {
  //remove all toast messages created by api-calls/page/... before displaying success message
  yield toast.dismiss();
  yield toast(t('messages.saved'), {
    transition: Slide,
    closeButton: true,
    autoClose: 2000,
    position: 'bottom-center',
    type: 'success',
  });
}

function* handleUpdateSuccess(action) {
  if (history.location.pathname.includes('admins')) {
    const state = yield select();

    yield put({
      type: memberActions.GET_MEMBERS.REQUEST,
      payload: {
        data: {
          page: 0,
          memberContains: get(state, 'Members.tableFilter.search'),
        },
      },
    });

    //remove all toast messages created by api-calls/page/... before displaying success message
    yield toast.dismiss();
    yield toast(t('messages.saved'), {
      transition: Slide,
      closeButton: true,
      autoClose: 2000,
      position: 'bottom-center',
      type: 'success',
    });

    return;
  }

  if (action.payload.options === 'redirect') {
    return yield history.push('/admins');
  } else {
    yield history.push(`/update-admin/${action.payload.id}`);
    //remove all toast messages created by api-calls/page/... before displaying success message
    yield toast.dismiss();
    yield toast(t('messages.saved'), {
      transition: Slide,
      closeButton: true,
      autoClose: 2000,
      position: 'bottom-center',
      type: 'success',
    });
  }
}

// function* handleUserOrganizationsRefresh() {
//   const getUserUuid = (state) => state.User.user.userUuid;
//   const userUuid = yield select(getUserUuid);

//   const arg = { id: userUuid }

//   yield apiRequest.apply(null, [ memberActions.getUserOrganizations, api.getUserOrganizations, arg ])
// }

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function* watchGetMembersRequest() {
  yield takeEvery(memberActions.GET_MEMBERS.REQUEST, getMembers);
}

export function* watchGetActiveMembersRequest() {
  yield takeEvery(memberActions.GET_ACTIVE_MEMBERS.REQUEST, getActiveMembers);
}

export function* watchGetInactiveMembersRequest() {
  yield takeEvery(memberActions.GET_INACTIVE_MEMBERS.REQUEST, getInactiveMembers);
}

export function* watchGetMemberRequest() {
  yield takeEvery(memberActions.GET_MEMBER.REQUEST, getMember);
}

export function* watchCreateMemberRequest() {
  yield takeEvery(memberActions.CREATE_MEMBER.REQUEST, createMember);
}

export function* watchUpdateMemberRequest() {
  yield takeEvery(memberActions.UPDATE_MEMBER.REQUEST, updateMember);
}

export function* watchUpdateMemberByAdminRequest() {
  yield takeEvery(memberActions.UPDATE_MEMBER_BY_ADMIN.REQUEST, updateMemberByAdmin);
}

export function* watchUpdateMemberByAdminSuccess() {
  yield takeEvery(memberActions.UPDATE_MEMBER_BY_ADMIN.SUCCESS, handleUpdateSuccess);
}

export function* watchUpdateMemberSuccess() {
  yield takeEvery(memberActions.UPDATE_MEMBER.SUCCESS, handleUpdateSuccess);
}

export function* watchDeleteMemberRequest() {
  yield takeEvery(memberActions.DELETE_MEMBER.REQUEST, deleteMember);
}

export function* watchUpdateMemberPasswordRequest() {
  yield takeEvery(memberActions.UPDATE_MEMBER_PASSWORD.REQUEST, updateMemberPassword);
}

export function* watchUpdateMemberPasswordSuccess() {
  yield takeEvery(memberActions.UPDATE_MEMBER_PASSWORD.SUCCESS, showMessage);
}

export function* watchDeleteMemberSuccess() {
  yield takeEvery(memberActions.DELETE_MEMBER.SUCCESS, refreshList);
}

export function* watchDeleteMemberByAdminRequest() {
  yield takeEvery(memberActions.DELETE_MEMBER_BY_ADMIN.REQUEST, deleteMemberByAdmin);
}

export function* watchDeleteMemberByAdminSuccess() {
  yield takeEvery(memberActions.DELETE_MEMBER_BY_ADMIN.SUCCESS, refreshList);
}

export function* watchCreateMemberByAdminRequest() {
  yield takeEvery(memberActions.CREATE_MEMBER_BY_ADMIN.REQUEST, createMemberByAdmin);
}

export function* watchCreateMemberByAdminSuccess() {
  yield takeEvery(memberActions.CREATE_MEMBER_BY_ADMIN.SUCCESS, handleCreateMemberSuccess);
}

export function* watchCreateMemberSuccess() {
  yield takeEvery(memberActions.CREATE_MEMBER.SUCCESS, handleCreateMemberSuccess);
}

export function* watchGetRoles() {
  yield takeEvery(memberActions.GET_ROLES.REQUEST, getRoles);
}
